import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/scss/app.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

const existAuth = JSON.parse(localStorage.getItem('user'));
axios.defaults.baseURL = process.env.REACT_APP_API_URI;
axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Authorization': `Bearer ${existAuth !== null && existAuth.access_token}`,
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};

ReactDOM.render(<App />, document.getElementById('app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
